import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Textbox,
  Radio,
  Alert,
  OverlayTrigger,
  Popover
} from 'adp-react-components';
import QuestionCircleIcon from 'adp-react-icons/lib/fa/question-circle';
import {
  loadHttpHeaders,
  loadAjaxBody
} from './../../../components/utils/utils.js';

function isValidCode(code) {
  return code != '';
}

class OtpVerificationCode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      verificationCode: '',
      deliveryMethodType: '',
      trainee: false,
        resendLinkVisible:true
    };
    console.log(
      'this.props.deliveryMediumType:' + this.props.deliveryMediumType
    );
  }
  componentWillMount() {
    this.setState({
      deliveryMethodType: this.props.deliveryMediumType
    });
    fetch(
      context+'/enroll/adpPassword.faces?stepupOtpDevicesAndActivationAjaxForm',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: loadHttpHeaders(),
        body: loadAjaxBody('stepupOtpDevicesAndActivationAjaxForm', '')
      }
    )
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (data.success == 'false' || data.success == false) {
          if (data.wizard.message == 'true') {
            this.props.showSessionExpired();
            return;
          }
          this.props.showErrorMessage(data.wizard.message);
          return;
        }
        if (data.activation.traine) {
          this.setState({
            verificationCode: data.activation.code,
            trainee: data.activation.traine
          });
        }
      });
  }

  onVerificationCode(value) {
      this.props.showSuccessAlertMessage('');
      this.props.showErrorMessage('');
    this.setState({
      verificationCode: value
    });
  }

  onResend(event) {
      this.props.showErrorMessage('');
      this.props.showSuccessAlertMessage('');
    var hasMultipleDevices = false;
    var count = 0;
    Object.values(this.props.stepupOtpDevices).map(value => {
      if (value != '') {
        count = count + 1;
      }
    });
    if (count > 1) {
      hasMultipleDevices = true;
    }
    console.log(
      'has multiple devices : ' +
        hasMultipleDevices +
        ' no.of devices :' +
        count
    );

    if (!hasMultipleDevices && !this.state.trainee) {
      console.log('non trainee mode');
      fetch(context+'/enroll/adpPassword.faces?stepupReSendActivationForm', {
        method: 'POST',
        credentials: 'same-origin',
        headers: loadHttpHeaders(),
        body: loadAjaxBody('stepupReSendActivationForm', '')
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          if (data.success == 'false' || data.success == false) {
            if (data.wizard.message == 'true') {
              this.props.showSessionExpired();
              return;
            }
            this.props.showErrorMessage(data.wizard.message);
            return;
          } else {
            this.props.showSuccessAlertMessage(
              this.props.resendAcCodeMessage +
                ' ' +
                this.state.deliveryMethodType
            );
            console.log('data.success ::' + data.success);
          }
        });
    } else if (!hasMultipleDevices && this.state.trainee) {
      console.log('trainee mode ');
      fetch(
        context+'/enroll/adpPassword.faces?stepupOtpDevicesAndActivationAjaxForm',
        {
          method: 'POST',
          credentials: 'same-origin',
          headers: loadHttpHeaders(),
          body: loadAjaxBody('stepupOtpDevicesAndActivationAjaxForm', '')
        }
      )
        .then(response => {
          return response.json();
        })
        .then(data => {
          if (data.success == 'false' || data.success == false) {
            if (data.wizard.message == 'true') {
              this.props.showSessionExpired();
              return;
            }
            this.props.showErrorMessage(data.wizard.message);
            return;
          }
          if (data.activation.traine) {
            this.setState({
              verificationCode: data.activation.code,
              trainee: data.activation.traine
            });
          }
        });
    } else {
      console.log('others');
      this.props.stepupOtpDevicesMethod(this.props.stepupOtpDevices);
      this.props.showOtpDevices(true);
    }
  }

  onSubmit(event) {
      this.props.showErrorMessage('');
        this.props.showSuccessAlertMessage('');
    fetch(context+'/enroll/adpPassword.faces?stepupVerifyActivationAjaxForm', {
      method: 'POST',
      credentials: 'same-origin',
      headers: loadHttpHeaders(),
      body: loadAjaxBody(
        'stepupVerifyActivationAjaxForm',
        'acCode=' + this.state.verificationCode
      )
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (data.success == 'false' || data.success == false) {
          if (data.wizard.message == 'true') {
            this.props.showSessionExpired();
            return;
          }
          var responseData = data.wizard.message;
          if(responseData.indexOf('UserLocked=Y') != -1){
            this.setState({
              resendLinkVisible: false
            });
            responseData = responseData.replace('UserLocked=Y','');
          }
          this.props.showErrorMessage(responseData, 'error');
          return;
        } else {
          window.location.href = context+'/enroll/redirect.faces';
        }
      });
  }

  onHasErrorChange(value) {
    this.setState({
      hasError: value
    });
  }

handleEnterKeyPress(e) {

    if (e.charCode == 13) {
      e.preventDefault(); //preventing html5 default form submit
      this.onSubmit();
    }
  }



  render() {
    var messageList = this.props.verificationCodeHelpMessage.map(function(
      message
    ) {
      return (
        <li key={message} value={message}>
          {message}
        </li>
      );
    });
    const popover = (
      <Popover
        id="popover-1"
        placement="bottom"
        title=""
        className="vdl-custom-popover-content">
        <ul className="verification-code-helper-content">{messageList}</ul>
      </Popover>
    );
    let isValid = isValidCode(this.state.verificationCode);
    return (
      <div className="vdl-row login-form">
        <div className="vdl-col-md-12">
          <form className="adp-form fyp">
            <div className="form-group password">
              <div className="form-group">
                <Radio
                  value={this.state.deliveryMethodType}
                  key={this.state.deliveryMethodType}
                  disabled={true}
                  className="vdl-radio__toggle-custom-readonly-text"
                  radioGroupValue={this.state.deliveryMethodType}>
                  {this.state.deliveryMethodType}
                </Radio>
              </div>
              <div className="vdl-row">
                <div className="vdl-col-sm-6 vdl-col-xs-12">
                  <label htmlFor="user_id">
                    {this.props.verificationcodeLabel}
                  </label>
                  <span className="verification-code-helper">
                    <OverlayTrigger
                      trigger="click"
                      placement="top"
                      overlay={popover}>
                      <QuestionCircleIcon />
                    </OverlayTrigger>
                  </span>
                </div>
                {/* vdl-col-sm-6 vdl-col-xs-12 */}

                {/*
									 * vdl-col-sm-6 hidden-xs vdl-text-xs-right
									 * vdl-hidden-sm-down
									 */}
              </div>
              {/* vdl-row */}
              <div className="form-group password">
                <div className="input-group-full">
                  <Textbox
                    autoFocus
                    value={this.state.verificationCode}
                    type="text"
                    onChange={this.onVerificationCode.bind(this)}
                    onKeyPress={this.handleEnterKeyPress.bind(this)}
                  />
                </div>
              </div>
              {/* input-group-full */}
            </div>
            {/* form-group */}

            {/* form-group password */}
            <div className="form-group submit vdl-text-xs-center">
              <Button
                className="primary"
                disabled={!isValid}
                onClick={this.onSubmit.bind(this)}>
                {this.props.submitcodeLabel}
              </Button>
            </div>
            {/* form-group submit vdl-text-xs-center */}
            </form>
          {/* adp-form */}
          <h5 className="vdl-text-xs-center forgot-password">
          {
                    this.state.resendLinkVisible
                      ?
            <a href="#" onClick={this.onResend.bind(this)}>
              {this.props.resendcodelink}{' '}
            </a>: null
        }
          </h5>
        </div>
        {/* vdl-col-md-12 */}
      </div>
    );
  }
}
OtpVerificationCode.propTypes = {
  verificationCode: PropTypes.string,
  submit: PropTypes.string,
  deliveryMethodType: PropTypes.string,
  successMessage: PropTypes.object
};

OtpVerificationCode.getDefaultProps = {
  verificationCode: undefined,
  submit: undefined,
  deliveryMethodType: undefined,
  successMessage: undefined
};

export default OtpVerificationCode;



// WEBPACK FOOTER //
// ./src/scenes/admin-login/stepup/otp-verification-code.js